var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "yoyo-container mx-auto min-h-screen pb-4 pb-[env(safe-area-inset-bottom)] bg-gray-50",
    },
    [
      _c("navBar", { attrs: { title: _vm.$t("products.reviews") } }),
      _c(
        "div",
        { staticClass: "w-[calc(100%-2rem)] mx-auto" },
        [
          _vm.reviews.length > 0
            ? _c(
                "van-pull-refresh",
                {
                  on: { refresh: _vm.onRefresh },
                  model: {
                    value: _vm.refreshing,
                    callback: function ($$v) {
                      _vm.refreshing = $$v
                    },
                    expression: "refreshing",
                  },
                },
                [
                  _c(
                    "van-list",
                    {
                      attrs: {
                        finished: _vm.finished,
                        "finished-text": _vm.$t("query.noMoreData"),
                        "loading-text": _vm.$t("query.loading"),
                      },
                      on: { load: _vm.onLoad },
                      model: {
                        value: _vm.loading,
                        callback: function ($$v) {
                          _vm.loading = $$v
                        },
                        expression: "loading",
                      },
                    },
                    [
                      !_vm.reviews.length && !_vm.loading
                        ? _c(
                            "div",
                            { staticClass: "text-center text-gray-500 py-8" },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("common.noData")) + " "
                              ),
                            ]
                          )
                        : _c(
                            "div",
                            { staticClass: "bg-white rounded-lg py-3 px-4" },
                            _vm._l(_vm.reviews, function (review) {
                              return _c(
                                "div",
                                { key: review.id, staticClass: "last:mb-0" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex items-center mb-2" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "w-6 h-6 rounded-full mr-2 text-xs bg-orange-300 text-white leading-6 text-center align-middle",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.firstLetter(
                                                  review.userNickname
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "text-sm font-medium" },
                                        [_vm._v(_vm._s(review.userNickname))]
                                      ),
                                      _c("van-rate", {
                                        staticClass: "ml-2",
                                        attrs: {
                                          readonly: "",
                                          size: "12",
                                          color: "#ffd21e",
                                          "void-color": "#eee",
                                        },
                                        model: {
                                          value: review.scores,
                                          callback: function ($$v) {
                                            _vm.$set(review, "scores", $$v)
                                          },
                                          expression: "review.scores",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-sm text-gray-700 mb-2 leading-relaxed",
                                    },
                                    [
                                      _c("div", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-sm text-gray-700 mb-1 leading-relaxed",
                                          },
                                          [_vm._v(_vm._s(review.content))]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-xs text-gray-400 mt-1",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatDate(
                                                  review.createTime
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                  review.id !==
                                  _vm.reviews[_vm.reviews.length - 1].id
                                    ? _c("van-divider")
                                    : _vm._e(),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.reviews.length === 0
            ? _c("van-empty", {
                attrs: { description: _vm.$t("common.noData") },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }